import React, {PropTypes as T} from 'react';

const Calendar2Icon = ({ width = 28, height = 26, color, className = '' }) => (
  <svg
    aria-label="Calendar Icon"
    viewBox="0 0 28 26"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__calendar2 ${className}`}>
    <path style={{fillRule: 'evenodd'}}
      d="M26.672 8.257H1.328l-.018-5.22 3.431-.01C4.822
        4.883 5.868 5.99 7.293 5.99c1.44 0 2.56-1.107 2.579-2.954h8.256c.02
        1.847 1.14 2.954 2.579 2.954 1.425 0 2.471-1.108 2.552-2.964l3.431.01-.018
        5.22zM1.328 24.31h25.344V9.586H1.328V24.31zM26.69 1.728h-3.378c-.704
        0-1.279.545-1.31 1.242-.049 1.135-.63 1.711-1.295 1.711-.662 0-1.246-.565
        -1.269-1.679a1.297 1.297 0 0 0-1.31-1.274H9.872c-.72 0-1.296.56-1.31 1.274-.023
        1.114-.608 1.68-1.269 1.68-.665 0-1.246-.577-1.296-1.712a1.302 1.302 0 0 0
        -1.309-1.242H1.31c-.722 0-1.31.58-1.31 1.29v21.465c0 .626.516 1.135 1.152
        1.135h25.696c.636 0 1.152-.509 1.152-1.135V3.019c0-.712-.588-1.29-1.31-1.29z
        M7.316 4.142a.66.66 0 0 0 .665-.654V.655A.66.66 0 0 0 7.316 0a.66.66 0 0 0
        -.664.655v2.833c0 .36.297.654.664.654m13.368 0a.66.66 0 0 0 .664-.654V.655A.66.66
        0 0 0 20.684 0a.66.66 0 0 0-.665.655v2.833c0 .36.299.654.665.654" />
  </svg>
);

Calendar2Icon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  Calendar2Icon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_calendar2.js